import { useContext, useState, Fragment } from 'react';
// import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Button, ButtonsContainer, ThemeContext } from '@forma/forma-ui-kit';
import RequestDemoModal3 from '@/components/blocks/RequestDemoModal3';
import PageBlock from '@/components/PageBlock';

import styles from './know-about.module.css';

// const lkUrl = process.env.LK_URL;

const barFullWidth = 261;

const KnowAbout = ({ title, description, image, template, counts, code, callModal }) => {
  const { t } = useTranslation();
  const { viewport } = useContext(ThemeContext);
  const isPhone = ['phone', 'tabletS'].includes(viewport);
  const [isRequest3Open, setRequest3Open] = useState(false);

  return (
    <PageBlock variant="filled" className={styles.root}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.description}>{description}</div>
          {!isPhone && (
            <ButtonsContainer className={styles.buttons}>
              <Button
                // as={Link}
                viewStyle="secondary"
                className={styles.button}
                // href={`${lkUrl}/register?lng=${lang}`}
                onClick={() => setRequest3Open(true)}
              >
                {callModal?.button ?? t('start_free')}
              </Button>
            </ButtonsContainer>
          )}
        </div>
        <div className={styles.images}>
          <Image src={image} className={styles.image} width={403} height={269} alt="" />

          <div className={styles.counts}>
            <div className={styles.countsTitle}>
              {counts.title}
            </div>
            <div className={classNames(styles.countsItem, styles.current)}>
              <div className={styles.countsName}>Вы</div>
              <div className={styles.progress}>
                <div className={styles.bar} style={{ width: (counts.current.width * 100 / barFullWidth).toFixed() + '%' }} />
                <span className={styles.count}>{counts.current.text}</span>
              </div>
            </div>
            <div className={classNames(styles.countsItem, styles.new)}>
              <div className={styles.countsName}>Вы + Forma</div>
              <div className={styles.progress}>
                <div className={styles.bar} style={{ width: (counts.new.width * 100 / barFullWidth).toFixed() + '%' }} />
                <span className={styles.count}>{counts.new.text}</span>
              </div>
            </div>
          </div>
          {template && (
            <div className={styles.template}>
              <img src="/icons/file_types/forma.svg" className={styles.templateIcon} width={30} height={35} alt="" />
              <div className={styles.templateName}>{template}</div>
            </div>
          )}
          {code && (
            <div className={styles.numbers}>
              {code.map((num, index) => (
                <Fragment key={num}>
                  <span className={styles.num}>
                    {num}
                  </span>
                  {index === 2 && (
                    <span className={styles.numDivider} />
                  )}
                </Fragment>
              ))}
            </div>
          )}
        </div>

        {isPhone && (
          <ButtonsContainer className={styles.buttons}>
            <Button
              // as={Link}
              viewStyle="secondary"
              className={styles.button}
              // href={`${lkUrl}/register?lng=${lang}`}
              onClick={() => setRequest3Open(true)}
              fullWidth
            >
              {callModal?.button ?? t('start_free')}
            </Button>
          </ButtonsContainer>
        )}
      </div>
      <RequestDemoModal3
        open={isRequest3Open}
        onClose={setRequest3Open}
        title={callModal?.title}
        description={callModal?.description}
      />
    </PageBlock>
  );
};

export default KnowAbout;
